import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { uncontrollable } from 'uncontrollable';
import warning from 'warning';
import { bsStyles, bsClass, getClassSet, splitBsPropsAndOmit } from '../bootstrap/utils/bootstrapUtils';
import { State, Style } from '../bootstrap/utils/StyleConfig';
import Body from '../bootstrap/PanelBody';
import Heading from '../bootstrap/PanelHeading';
import Title from '../bootstrap/PanelTitle';
import Footer from '../bootstrap/PanelFooter';
import Toggle from '../bootstrap/PanelToggle';
import Collapse from '../bootstrap/PanelCollapse';
import { PanelGroupContext, PanelContext } from './PanelContext';
import { jsx as _jsx } from "react/jsx-runtime";
const has = Object.prototype.hasOwnProperty;
const defaultGetId = (id, type) => id ? `${id}--${type}` : null;
class Panel extends React.Component {
  constructor() {
    super(...arguments);
    this.handleToggle = e => {
      const panelGroup = this.context;
      const expanded = !this.getExpanded();
      if (panelGroup && panelGroup.onToggle) {
        panelGroup.onToggle(this.props.eventKey, expanded, e);
      } else {
        this.props.onToggle(expanded, e);
      }
    };
  }
  getPanelContext() {
    const {
      eventKey,
      id
    } = this.props;
    const idKey = eventKey == null ? id : eventKey;
    let ids;
    if (idKey !== null) {
      const panelGroup = this.context;
      const getId = panelGroup && panelGroup.getId || defaultGetId;
      ids = {
        headingId: getId(idKey, 'heading'),
        bodyId: getId(idKey, 'body')
      };
    }
    return {
      ...ids,
      bsClass: this.props.bsClass,
      expanded: this.getExpanded(),
      onToggle: this.handleToggle
    };
  }
  getExpanded() {
    const panelGroup = this.context;
    if (panelGroup && has.call(panelGroup, 'activeKey')) {
      process.env.NODE_ENV !== "production" ? warning(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;
      return panelGroup.activeKey === this.props.eventKey;
    }
    return !!this.props.expanded;
  }
  render() {
    const {
      className,
      children
    } = this.props;
    const [bsProps, props] = splitBsPropsAndOmit(this.props, ['onToggle', 'eventKey', 'expanded']);
    const contextValue = this.getPanelContext();
    return /*#__PURE__*/_jsx(PanelContext.Provider, {
      value: contextValue,
      children: /*#__PURE__*/_jsx("div", {
        ...props,
        className: clsx(className, getClassSet(bsProps)),
        children: children
      })
    });
  }
}
Panel.contextType = PanelGroupContext;
const UncontrolledPanel = uncontrollable(bsClass('panel', bsStyles([...Object.values(State), Style.DEFAULT, Style.PRIMARY], Style.DEFAULT, Panel)), {
  expanded: 'onToggle'
});
Object.assign(UncontrolledPanel, {
  Heading,
  Title,
  Body,
  Footer,
  Toggle,
  Collapse
});
export default UncontrolledPanel;